import { FC } from 'react';
import { FirmwareProtocol } from '../../pages/sensors-v2/types/sensors';

type Props = {
  protocol?: FirmwareProtocol;
  size?: 'sm' | 'xs';
};

// Visual indicator of how a measuring box reports state. WS firmware fires
// alarm events instantly via the gateway; HTTP polling has a few seconds of
// reporting latency plus up to ~60s of UI polling latency.
export const ProtocolChip: FC<Props> = ({ protocol, size = 'sm' }) => {
  if (!protocol) return null;
  const isWs = protocol === 'ws';
  const fontSize = size === 'xs' ? 9 : 10;
  const padding = size === 'xs' ? '1px 4px' : '2px 6px';
  return (
    <span
      title={isWs ? 'Comunicação em tempo real (WebSocket)' : 'Reporte por polling HTTP (latência maior)'}
      style={{
        display: 'inline-block',
        fontSize,
        fontWeight: 700,
        padding,
        borderRadius: 4,
        background: isWs ? '#dcfce7' : '#fef3c7',
        color: isWs ? '#15803d' : '#92400e',
        letterSpacing: 0.3,
        lineHeight: 1.2,
      }}
    >
      {isWs ? '⚡ WS' : '📡 HTTP'}
    </span>
  );
};
